import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import { getNativeContext } from '../helpers/get-native-context'; // The DEFAULT_OPTIONS are only of type Partial<IPeriodicWaveOptions> because there are no default values for imag and real.

var DEFAULT_OPTIONS = {
  disableNormalization: false
};
export var createPeriodicWaveConstructor = function createPeriodicWaveConstructor(createNativePeriodicWave) {
  return function PeriodicWave(context, options) {
    _classCallCheck(this, PeriodicWave);

    var nativeContext = getNativeContext(context);

    var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options); // This does violate all good pratices but it is used here to simplify the handling of periodic waves.


    return createNativePeriodicWave(nativeContext, mergedOptions);
  };
};